export { default as validate } from './validate';
export { default as create } from './create';
export { default as addItem } from './addItem';
export { default as duplicate } from './duplicate';
export { default as getQR } from './getQR';
export { default as checkUrl } from './targetCheck/url';
export { default as checkId } from './targetCheck/id';
export { default as checkGetSettings } from './targetCheck/getSettings';
export { default as checkUpdateSettings } from './targetCheck/updateSettings';



// WEBPACK FOOTER //
// ./src/services/api/link/index.ts